import { useTranslation } from "react-i18next";
import moment from "moment/moment";
import React, {useCallback, useEffect, useState} from 'react';
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import {
  Checkbox,
  FormLabel,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import * as _ from "lodash";

import config from "../../app/config";
import makeStyles from "@mui/styles/makeStyles";
import {AttendanceCategory} from '../../controls/agyle/dictionaries';
import AgyleDatePicker from "../../components/ui/fields/agyleDatePicker";
import AgyleBlockSwitch from "../../components/ui/switch/agyleBlockSwitch";
import AgyleTextField from "../../components/ui/fields/agyleTextField";
import AgyleDictionaryField from "../../components/ui/selector/agyleDictionaryField";
import Divider from '@mui/material/Divider';
import InformationBox from '../../components/other/informationBox';
import AgyleButton from '../../components/ui/buttons/agyleButton';
import {useStylesECDS} from '../ward/forms/ecds/ecdsStyle';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import {ChiefOfComplaintECDS} from '../../controls/agyle/ecds';

const useStyles = makeStyles((theme) => ({
  body: {
    width: "90%",
    margin: "30px 5% 5% 5%",
  },
  content: {
    padding: 20,
    margin: 20,
  },
  bodyTitle: {
    // paddingLeft: 20
    fontSize: 18,
  },
  title: {
    textAlign: "center",
    width: "100%",
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  search: {
    // position: 'relative',
    borderRadius: theme.shape.borderRadius,
    //backgroundColor: theme.palette.background.paper,
    "&:hover": {
      // backgroundColor: theme.palette.background.,
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    // marginTop: '20px',
    width: "60% !important",
    left: "20%",
    position: "fixed",
    marginTop: "-64px",
    fontSize: 20,
    textAlign: "center",
    // backgroundColor: 'rgb(54 54 54)' //theme.palette.background.default // '#252525'
    //   backgroundColor: theme.palette.mode === 'light' ? '#cecece' : '#363636'
  },

  searchInput: {
    padding: "20px 0 20px 0",

    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      paddingLeft: " 40px !important",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    //height: '100%',
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.mainColor,
    marginLeft: 0,
    marginTop: 8,
  },
  fullName: {
    display: "inline-block",
    marginLeft: 10,
    fontWeight: 300,
  },
  familyName: {
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: 5,
  },
  vvip: {
    color: "#e46060",
    border: "1px solid #e46060",
    padding: "3px",
    fontSize: "10px",
    marginRight: "6px",
    borderRadius: "16px",
    verticalAlign: "middle",
    display: "inline-block",
    height: "20px",
  },
  patientsTable: {},
  searchButtons: {
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#363636",
    padding: "5px",
    marginBottom: "7px",
    color: "gray",
    fontSize: 12,
  },
  tableRecord: {
    padding: "8px",
    marginBottom: "7px",
    backgroundColor: theme.palette.mode === "light" ? "#cacaca" : "#434343",
    // backgroundColor: "rgb(67 67 67)",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.default.main,
    },
  },
  pagination: {
    width: "fit-content",
    margin: "auto",
  },
  fullNameHeader: {
    marginLeft: "10px",
  },
  sortedHeader: {
    cursor: "pointer",
  },
  buttonSelector: {
    borderRadius: 50,
    backgroundColor: theme.palette.grey["300"],
    color: "rgba(0, 0, 0, 0.87)",
    margin: "0 5px",
    fontSize: 10,
  },
  headerText: {
    float: "left",
    marginTop: 4,
  },
  formControl: {
    width: "100%",
  },
  next: {
    width: "50%",
    margin: "auto",
  },
  error: {
    color: "#f44336",
  },
  patientHeaderItem: {
    fontSize: 14,
    verticalAlign: "top",
    lineHeight: "24px",
    display: "inline-block",
    margin: "0 5px",
    backgroundColor: theme.palette.background.paper,
    padding: "2px 7px",
    borderRadius: 5,
    "& .label": {
      marginRight: 5,
      fontSize: "90%",
    },
    "& .value": {
      fontWeight: "bold",
    },
  },
  groupRoot: {
    marginBottom: 10,
    padding: 5,
    borderRadius: 5,
  },
  paper: {
    padding: 10,
    backgroundColor: theme.palette.background.default,
  },
  centerRow: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
  },
  userLog: {
    fontSize: 11,
    fontStyle: "italic",
    color: theme.palette.mode === "light" ? "#4B4B4B" : "#818181",
  },
  comment: {
    fontSize: 15,
    padding: 5,
    backgroundColor: theme.palette.background.default,
    borderRadius: 5,
  },
  clinician: {
    marginBottom: 10,
  },
  row: {
    width: "100%",
    marginBottom: 10,
  },
  feedback: {
    display: 'flex',
    justifyContent: 'space-between',
  }
}));

const EscortList = (props) => {
  const { t } = useTranslation();
  const classes = useStylesECDS();

  const { admit, deleteItem } = props;

  const escortList = admit.escortArray;

  const {} = props;
  return (
    escortList &&
    escortList.length > 0 && (
      <TableContainer component={Paper} className={classes.table}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">{t("No")}</TableCell>
              <TableCell>{t("Person Name")}</TableCell>
              <TableCell align="center">
                {t("Parental Responsibility")}
              </TableCell>
              <TableCell align="center">{t("Attended with child")}</TableCell>
              <TableCell align="right">{t("Age")}</TableCell>
              <TableCell align="right">{t("Relationship")}</TableCell>
              <TableCell align="right">{t("Contact Details")}</TableCell>
              <TableCell align="center">{t("Delete")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {escortList &&
              escortList.length > 0 &&
              escortList.map((row, index) => (
                <TableRow
                  key={row.id + index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {index + 1}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell align="center">
                    <Checkbox
                      checked={row.parentalResponsibility}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Checkbox checked={row.attendedWithChild} disabled={true} />
                  </TableCell>
                  <TableCell align="right">{row.age}</TableCell>
                  <TableCell align="right">{row.relationship}</TableCell>
                  <TableCell align="right">{row.contact}</TableCell>
                  <TableCell align="center">
                    <Button
                      // disabled={props.disableSave || !dispatch(hasPermission(Permissions.AGYLE_CAN_MANAGE_HOUSEHOLD))}
                      // disabled={checkDisabled()}
                      onClick={() => deleteItem(index)}
                    >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  );
};

const EscortSection = (props) => {
  const {admission, setAdmission} = props;
  const {t} = useTranslation();

  const initEscort = {
    name: "",
    phone: "",
    relationship: "",
    parentalResponsibility: false,
    attendedWithChild: false,
    contact: "",
  };
  const [escortForm, setEscortForm] = useState(initEscort);

  const informationMessage =
    "Please add who does have parental/legal responsibility for the patient and what are their contact details, and who attended with a child";

  const handleChangeEscort = (e) => {
    const { name, value } = e.target;

    setEscortForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddEscort = () => {
    let escortArr;

    if (admission.escortArray.length === 0) {
      escortArr = [escortForm];
    } else {
      escortArr = [...admission.escortArray, escortForm];
    }
    setAdmission((prevState) => ({
      ...prevState,
      escortArray: escortArr,
    }));
    setEscortForm(initEscort);
  };

  const handleRemoveEscort = (index) => {
    const newEscortArray = admission.escortArray.filter((escort, i) => i !== index);

    setAdmission((prevState) => ({
      ...prevState,
      escortArray: newEscortArray,
    }));
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{ m: 1, pr: 3, pl: 0 }}
        alignItems="center"
      >
        <div style={{ width: "100%", marginRight: "16px" }}>
          <InformationBox type={"info"}>
            {t(informationMessage)}
          </InformationBox>
        </div>
        <Grid item xs={12} md={6} sx={{ mt: 2, pl: 0 }}>
          <Stack direction={"row"}>
            <Grid item xs={6}>
              <FormLabel sx={{ mr: 3 }}>
                {t("Parental Responsibility")}
              </FormLabel>
            </Grid>

            <Grid item xs={4}>
              <AgyleBlockSwitch
                onChange={() =>
                  setEscortForm((prevValue) => ({
                    ...prevValue,
                    parentalResponsibility: !prevValue.parentalResponsibility,
                  }))
                }
                value={escortForm.parentalResponsibility || false}
                style={{ marginRight: 10 }}
              />
            </Grid>
          </Stack>

          <Stack direction={"row"} sx={{ mt: 0.5 }}>
            <Grid item xs={6}>
              <FormLabel sx={{ mr: 3 }}>
                {t("Attended with a child")}
              </FormLabel>
            </Grid>
            <Grid item xs={4}>
              <AgyleBlockSwitch
                // disabled={checkDisabled()}
                onChange={(val) =>
                  setEscortForm((prevValue) => ({
                    ...prevValue,
                    attendedWithChild: !prevValue.attendedWithChild,
                  }))
                }
                value={escortForm.attendedWithChild || false}
                style={{ marginRight: 10 }}
              />
            </Grid>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={4}>
          <AgyleTextField
            size={"large"}
            fullWidth
            multiline
            variant="outlined"
            label={t("Name")}
            value={escortForm?.name || ""}
            name="name"
            onChange={handleChangeEscort}
            // disabled={checkDisabled()}
          />
        </Grid>

        <Grid item xs={12} sm={2}>
          <AgyleTextField
            size={"large"}
            fullWidth
            multiline
            variant="outlined"
            label={t("Age")}
            type="text"
            inputProps={{
              maxLength: 3,
              inputMode: "numeric",
              pattern: "/^-?d+(?:.d+)?$/g",
            }}
            name="age"
            value={escortForm?.age || ""}
            // disabled={checkDisabled()}
            onChange={(e) => {
              e.stopPropagation();
              e.preventDefault();
              e.currentTarget.value = e.target.value.replace(/[\D\s]/, "");
              handleChangeEscort(e);
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <AgyleTextField
            size={"large"}
            fullWidth
            multiline
            variant="outlined"
            label={t("Relationship")}
            name="relationship"
            // disabled={checkDisabled()}
            value={escortForm?.relationship || ""}
            onChange={handleChangeEscort}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <AgyleTextField
            size={"large"}
            multiline
            variant="outlined"
            label={t("Contact Details")}
            // disabled={checkDisabled()}
            fullWidth
            name="contact"
            value={escortForm?.contact || ""}
            onChange={handleChangeEscort}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={3}>
          <AgyleButton
            onClick={handleAddEscort}
            variant="contained"
            size="large"
            // disabled={checkDisabled()}
          >
            {t("ADD NEW ESCORT")}
          </AgyleButton>
        </Grid>

        <Grid item xs={12}>
          <EscortList
            admit={admission}
            deleteItem={handleRemoveEscort}
          />
        </Grid>
      </Grid>
    </>
  )
}

const AdmissionDetails = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    admission,
    setAdmission,
    continueAttendanceRef,
    chiefComplaintOptions,
    arrivalModeOptions,
    isArrivalModeOptionsLoading,
    isChiefComplaintOptionsLoading,
    attendanceSourceOptions,
    isAttendanceSourceOptionsLoading,
    attendanceTypeOptions,
    isAttendanceTypeOptionsLoading,
    locationOptions,
    isLocationOptionsLoading,
    patientOnWhiteboard,
    patientAge,
    attendanceCategoryOptions,
    isBedas,
    admit,
    tempPatient,
    conveyingAmbulanceOptions,
    conveyingAmbulanceLoading,
    bedasRemove,
  } = props;

  const isPatientArrivedByAmbulance = () =>
    admission?.modeOfArrival?.group === "ambulance" || admission?.modeOfArrival?.ambulance;

  useEffect(() => {
    let continueAdmissionAttendanceSource;
    let continueAdmissionArrivalMode;
    let continueAdmissionLocation;
    let continueAdmissionAttendanceType;
    let continueAdmissionChiefComplaint;
    let continueAdmissionClone;

    const defaultAttendanceSource =
      !_.isEmpty(attendanceSourceOptions) &&
      attendanceSourceOptions.find(
        (item) =>
          item.__description ===
          "Self / family / friends / education / work colleague"
      );

    const defaultArrivalMode =
      !_.isEmpty(arrivalModeOptions) &&
      arrivalModeOptions.find(
        (item) =>
          item.__description === "Patient arranged own transport / walk-in"
      );

    const defaultLocation =
      !_.isEmpty(locationOptions) &&
      locationOptions.find((item) => item.__code === "E");

    const bedasPt = (isBedas || (tempPatient && admit?.tags?.includes('bedas')) && !bedasRemove);
    const defaultAttendanceTypeCode = bedasPt ? 'P' : 'F';
    const defaultAttendanceType =
      !_.isEmpty(attendanceTypeOptions) &&
      attendanceTypeOptions.find((item) => item.__code === defaultAttendanceTypeCode);

    let defaultAttendanceCategory = null;
    if (bedasPt) {
      defaultAttendanceCategory = !_.isEmpty(attendanceCategoryOptions) &&
          attendanceCategoryOptions.find((item) => item.__code === '4');
    }

    if (!admission.attendanceSource && !continueAttendanceRef.current) {
      setAdmission((prevState) => ({
        ...prevState,
        attendanceSource: defaultAttendanceSource,
      }));
    }
    if (!admission.modeOfArrival && !continueAttendanceRef.current) {
      setAdmission((prevState) => ({
        ...prevState,
        modeOfArrival: defaultArrivalMode,
      }));
    }
    if (!admission.location && !continueAttendanceRef.current) {
      setAdmission((prevState) => ({
        ...prevState,
        location: defaultLocation,
      }));
    }
    if (!admission.attendanceType && !continueAttendanceRef.current) {
      setAdmission((prevState) => ({
        ...prevState,
        attendanceType: defaultAttendanceType,
        attendanceCategory: defaultAttendanceCategory,
      }));
    }

    if (continueAttendanceRef.current) {
      continueAdmissionClone = _.cloneDeep(continueAttendanceRef.current);

      // continueAdmissionAttendanceSource = continueAttendanceRef.current?.attendanceSource;
      continueAdmissionArrivalMode = !_.isEmpty(arrivalModeOptions) &&
          arrivalModeOptions.find(
              (item) =>
                  item.__description === continueAdmissionClone?.arrivalModeDescription
          );

      continueAdmissionLocation = !_.isEmpty(locationOptions) &&
          locationOptions.find(
              (item) =>
                  item.__description === continueAdmissionClone?.location
          );

      continueAdmissionAttendanceType = !_.isEmpty(attendanceTypeOptions) &&
          attendanceTypeOptions.find(
              (item) =>
                  item.__description === continueAdmissionClone?.attendanceTypeDescription
          );

      setAdmission(prevState => ({
        ...prevState,
        chiefComplaint: continueAdmissionClone?.chiefComplaint || null,
        modeOfArrival: continueAdmissionArrivalMode || defaultArrivalMode,
        location: continueAdmissionLocation || defaultLocation,
        attendanceType: continueAdmissionAttendanceType || defaultAttendanceType,
        attendanceSource: continueAdmissionAttendanceSource || defaultAttendanceSource,
        attendanceCategory: defaultAttendanceCategory,
      }));

      continueAttendanceRef.current = null;
    }
  }, [
    arrivalModeOptions,
    attendanceSourceOptions,
    attendanceTypeOptions,
    locationOptions,
    continueAttendanceRef.current,
    attendanceCategoryOptions,
    isBedas,
  ]);

  const handleChangeSwitch = useCallback((e, name) => {
    let newValue = {
      ...admission,
      [name]: e,
    };

    if (name === "flag111" && !e) {
        newValue = {
            ...newValue,
            flag111Timestamp: null,
        };
    }

    setAdmission(newValue);
  }, [admission]);

  const renderSwitchSection = (name, label, value, nullStateSwitch = false, redLabel, conditionalRender = true) => {
    return (
      conditionalRender && <Grid item xs={12}>
        <div className={classes.groupRoot}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <div className={classes.centerRow}>
              <FormLabel sx={{ mr: 3, minWidth: "140px", maxWidth: '140px', color: redLabel && "#FF6868" }}>
                {t(label)}
              </FormLabel>

              <AgyleBlockSwitch
                onChange={(e) => handleChangeSwitch(e, name)}
                value={admission[name]}
                style={{ marginRight: "10px" }}
              />

              {name === "flag111" && (
                <div style={{ marginLeft: "15px" }}>
                  <AgyleDatePicker
                    value={admission.flag111Timestamp}
                    label={t("Date and Time")}
                    error={admission.flag111 && !admission.flag111Timestamp}
                    disabled={!admission.flag111}
                    type="dateTime"
                    // maxDate={moment()}
                    onChange={(e) => {
                      setAdmission((prevState) => ({
                        ...prevState,
                        flag111Timestamp: e,
                      }));
                    }}
                  />
                </div>
              )}
            </div>
          </Grid>
          {!_.isEmpty(admission[`${name}User`]) && (
            <div className={classes.userLog}>
              {`${admission[`${name}User`]} ${
                admission[`${name}Timestamp`]
                  ? moment(admission[`${name}Timestamp`]).format(
                      config.defaultDateTimeFormat
                    )
                  : ""
              }`}
            </div>
          )}
        </div>
      </Grid>
    );
  };

  const getConveyingAmbulanceOptions = () => {
    if (admission.conveyingAmbulanceOrgId) {
      return _.find(conveyingAmbulanceOptions, {__description: admission.conveyingAmbulanceOrgId}) || null;
    }
    return null;
  };

  return (
    <Paper>
      <div className={classes.content}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <ChiefOfComplaintECDS
                label={t('Chief Complaint')}
                value={admission.chiefComplaint}
                onChange={(e, val) => {
                  setAdmission((prevState) => ({
                    ...prevState,
                    chiefComplaint: val,
                  }));
                }}
                size="large"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <AgyleDatePicker
              label={t("Attendance Date")}
              size={"large"}
              inputFormat={config.defaultDateFormat}
              inputVariant="outlined"
              value={admission.admitDate}
              type="dateTime"
              maxDateTime={moment()}
              onChange={(e) => {
                setAdmission((prevState) => ({ ...prevState, admitDate: e }));
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <AgyleDictionaryField
                label={`Attendance Type`}
                size={"large"}
                onChange={(_e, val) =>
                    setAdmission((prevState) => ({
                      ...prevState,
                      attendanceType: val,
                    }))
                }
                options={attendanceTypeOptions}
                value={admission.attendanceType}
                loading={isAttendanceTypeOptionsLoading}
                // disabled={!form[field]}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <AgyleDictionaryField
                label={`Attendance Source`}
                size={"large"}
                onChange={(_e, val) =>
                    setAdmission((prevState) => ({
                      ...prevState,
                      attendanceSource: val,
                    }))
                }
                options={attendanceSourceOptions}
                value={admission.attendanceSource}
                loading={isAttendanceSourceOptionsLoading}
                // disabled={!form[field]}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <AgyleDictionaryField
                label={`Location`}
                size={"large"}
                onChange={(_e, val) =>
                    setAdmission((prevState) => ({
                      ...prevState,
                      location: val,
                    }))
                }
                options={locationOptions}
                value={admission.location}
                loading={isLocationOptionsLoading}
                // disabled={!form[field]}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <AgyleDictionaryField
                label={`Arrival Mode`}
                size={"large"}
                onChange={(_e, val) =>
                    setAdmission((prevState) => ({
                      ...prevState,
                      modeOfArrival: val,
                    }))
                }
                options={arrivalModeOptions}
                value={admission.modeOfArrival}
                loading={isArrivalModeOptionsLoading}
                // disabled={!form[field]}
                error={!admission.modeOfArrival}
            />
          </Grid>

          {!patientOnWhiteboard && <Grid item xs={6}>
            <AgyleTextField
              size={"large"}
              multiline
              fullWidth
              label={t("History of Presenting Complaint")}
              value={admission.historyOfPresentingComplaint}
              onChange={(e) => setAdmission(prevState => ({
                ...prevState,
                historyOfPresentingComplaint: e.target.value
              })
              )}
              />
          </Grid>}

          <Grid item xs={6}>
            <AttendanceCategory
                name="attendanceCategory"
                label={t('Emergency Care Attendance Category')}
                value={admission.attendanceCategory}
                onChange={(_e, val) => setAdmission(prevState => ({
                  ...prevState,
                  attendanceCategory: val,
                }))}
                size="large"
                error={!admission.attendanceCategory}
            />
          </Grid>

          <Grid item xs={12}>
            {isPatientArrivedByAmbulance() &&
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <AgyleTextField
                        size={'large'}
                        required
                        fullWidth
                        variant="outlined"
                        label={t('Ambulance Incident Number')}
                        error={!admission.ambulanceIncidentNumber}
                        value={admission.ambulanceIncidentNumber || ''}
                        onChange={(e) => {
                          const val = e.target.value;
                          const valCare = val ? `${val.replace('-', '')}-` : '';

                          setAdmission((prevState) => ({
                            ...prevState,
                            ambulanceIncidentNumber: val,
                            careContactIdentifier: valCare,
                          }))
                        }}
                        type="ambulance"
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <AgyleTextField
                        size={'large'}
                        required
                        fullWidth
                        variant="outlined"
                        label={t('Care Contact Identifier')}
                        value={admission.careContactIdentifier || ''}
                        error={!admission.careContactIdentifier}
                        onChange={(e) =>
                            setAdmission((prevState) => ({
                              ...prevState,
                              careContactIdentifier: e.target.value,
                            }))
                        }
                        type="ambulance"
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <AgyleDictionaryField
                        label={`Org Id - Conveying Ambulance Trust`}
                        size={'large'}
                        onChange={(_e, val) =>
                            setAdmission((prevState) => ({
                              ...prevState,
                              conveyingAmbulanceOrgId: val?.__description,
                            }))
                        }
                        options={conveyingAmbulanceOptions}
                        error={!admission.conveyingAmbulanceOrgId}
                        value={getConveyingAmbulanceOptions()}
                        required
                        loading={conveyingAmbulanceLoading}
                    />
                  </Grid>
                </Grid>
            }
          </Grid>

          <Grid item xs={12} className={classes.feedback}>
            <FormLabel>
              {t("Do you consent to being contacted by the Trust to give feedback with the care you receive?")}
            </FormLabel>

            <AgyleBlockSwitch
                onChange={(e) => handleChangeSwitch(e, 'feedback')}
                value={admission?.feedback}
                style={{ marginRight: "10px" }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            {renderSwitchSection("flag111", config.gpExpected ? "GP Expected Flag": "111 Flag", admission?.flag111)}
            {renderSwitchSection(
                "majorTraumaFlag",
                "Major Trauma",
                admission.majorTraumaFlag
            )}
            {renderSwitchSection(
                "assaultRelated",
                "Is Attendance Assault Related",
                admission.assaultRelated,
                false,
                false,
                config?.attendanceAssaultRelatedFlagEnabled
            )}
          </Grid>
          {patientAge < 18 && <>
            <Grid item xs={12} md={6} sx={{mt: 0.5}}>
              {renderSwitchSection(
              "cpIs",
              "CP-IS Checked?",
              admission.cpIs,
              false,
              !admission.cpIs
            )}
              <div style={{width: '100%', height: '7px'}} />
              {admission.cpIs && renderSwitchSection(
                "cpIsAlertPresent",
                "CP-IS Alert Present",
                admission.cpIsAlertPresent
              )}
            </Grid>

            <>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Divider textAlign="left">Escort</Divider>
              </Grid>

              <EscortSection
                admission={admission}
                setAdmission={setAdmission}
              />
            </>

          </>}
        </Grid>
      </div>
    </Paper>
  );
};

export default AdmissionDetails;
